<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Existencias del producto</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Productos</a>
        </li>
        <li class="breadcrumb-item active">Existencia</li>
      </ol>
    </div>
    <div class="card" v-if="mevengo === true">
      <div class="card-header">
        <div class="form-group">
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Nombre del producto</strong> </label>
                <p v-text="product.name"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Estado</strong> </label>
                <br>
                <span v-if="product.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </div>
            </div>
            <div class="input-group">
              <input type="text" v-model="search" @keyup="fetchData(1,product.id,search, checkboxmanual)"  class="form-control" placeholder="Ingrese el código del producto">
              <button type="submit" @click="fetchData(1,product.id,search, checkboxmanual)" class="btn btn-theme"><i class="icon-fa icon-fa-search"></i> Buscar</button>
            </div>

            <br>
            <div class="custom-control custom-checkbox mb-3">
              <input
                id="customControlValidation1"
                type="checkbox"
                class="custom-control-input"
                v-model="checkboxmanual"
                required
                @change="fetchData(1, product.id ,search, checkboxmanual)"
              >
              <label v-if="checkboxmanual === false" class="custom-control-label" for="customControlValidation1">
                Mostrar datos inactivos
              </label>
              <label v-else class="custom-control-label" for="customControlValidation1">
                Mostrar datos activos
              </label>
              <div class="invalid-feedback">Example invalid feedback text</div>
            </div>

        </div>
      </div>
      <div class="card-body">
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>Código</th>
              <th>Existencia</th>
              <th>Ubicación física</th>
              <th>Precio de compra</th>
              <th>Precio especial</th>
              <th>Precio de venta</th>
              <th>Medida</th>
              <th>Sucursal</th>
              <th>Estado</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="products in productsArray" :key="products.id">
              <td v-text="products.code"></td>
              <td v-text="products.stock"></td>
              <td v-text="products.location"></td>
              <td v-text="formatQuetzales(products.purchase_price)"></td>
              <td v-text="formatQuetzales(products.special_price)"></td>
              <td v-text="formatQuetzales(products.sales_price)"></td>
              <td v-text="products.measure.equal"></td>
              <td v-text="products.place.name"></td>
              <td>
                <span v-if="products.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td>
                <template>
                  <div class="btn-group mr-2"
                    role="group"
                    aria-label="First group"
                  >
                    <router-link v-tooltip.top-center="'Ver historial de precios'" :to="`/admin/products/historial?item=${products.id}`" class="btn btn-info"><i class="icon-fa icon-fa-file-text"/></router-link>
                    <router-link v-tooltip.top-center="'Ver ajustes de inventario'" :to="`/admin/products/ajuste?item=${products.id}`" class="btn btn-light"><i class="icon-fa icon-fa-cogs"/></router-link>
                    <button v-tooltip.top-center="'Imprimir código'" class="btn btn-dark" @click="openModal('print', products)"><i class="icon-fa icon-fa-barcode"/></button>
                    <button v-tooltip.top-center="'Editar precios y código'" class="btn btn-theme" @click="openModal('update', products)"><i class="icon-fa icon-fa-pencil"/></button>
                    <a/>
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button v-tooltip.top-center="'Ajustar inventario'" class="btn btn-secondary" @click="openModal('adjustment', products)"><i class="icon-fa icon-fa-balance-scale"/></button>
                    <button v-tooltip.top-center="'Cambiar ubicación física'" class="btn btn-success" @click="openModal('ubicacion', products)"><i class="icon-fa icon-fa-map-marker"/></button>
                    <button v-tooltip.top-center="'Desactivar existencia'" v-if="products.state==1" class="btn btn-danger" @click="openModal('deactivate', products)"><i class="icon-fa icon-fa-trash"/></button>
                    <button v-tooltip.top-center="'Activar existencia'" v-else class="btn btn-info" @click="openModal('activate', products)"><i class="icon-fa icon-fa-check"/></button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Paginación de tabla-->
        <div class="card">
            <div class="card-body">
                <ul class="pagination pagination-primary m-b-0">
                    <li class="page-item" v-if="pagination.current_page > 1">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search, checkboxmanual)"><i class="icon-fa icon-fa-angle-left"></i></a>
                    </li>
                    <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                        <a class="page-link" href="#" @click.prevent="changePage(page, search, checkboxmanual)" v-text="page"></a>
                    </li>
                    <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search, checkboxmanual)"><i class="icon-fa icon-fa-angle-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
      </div>
       <!-- MODALES -->
      <sweet-modal ref="existencia_modal" :title="titleModal" hide-close-button blocking>
        <!-- START FORM -->
        <div class="card-body">
          <div class="form-group">
            <label>Existencia</label>
            <input
              :class="{ 'is-invalid': $v.stock.$error }"
              v-model.trim="stock"
              class="form-control"
              type="number"
              min="1"
              @input="$v.stock.$touch()"
              :disabled="adjustment"
            />
            <div v-if="$v.stock.$error">
              <span
                v-if="!$v.stock.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Ubicación</label>
            <input
              :class="{ 'is-invalid': $v.location.$error }"
              v-model.trim="location"
              class="form-control"
              placeholder="Ingrese ubicación del producto"
              @input="$v.location.$touch()"
              :disabled="simple"
            />
            <div v-if="$v.location.$error">
              <span
                v-if="!$v.location.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>

          <div class="form-group">
              <label>Código</label>
              <input
                :class="{ 'is-invalid': $v.code.$error }"
                v-model.trim="code"
                class="form-control"
                placeholder="Ingrese código del producto"
                @input="$v.code.$touch()"
                :disabled="edit"
              />
              <template>
                <button v-if="edit===false" class="btn btn-success btn-block" @click="openModal('code', '')">Generar código <i
                  class="icon-fa icon-fa-random" /></button>
              </template>
              <div v-if="$v.code.$error">
                <span
                  v-if="!$v.code.required"
                  class="help-block help-block-error"
                >El campo es requerido</span>
              </div>
              <barcode :value="code" :options="{ lineColor: '#0275d8', text: 'Scan'}"></barcode>
          </div>

          <div class="form-group">
            <label>Precio costo</label>
            <masked-input
              v-model="purchase_price"
              :guide="false"
              :mask="mask_quetzal"
              :class="{ 'is-invalid': $v.purchase_price.$error }"
              type="text"
              class="form-control"
              @input="$v.purchase_price.$touch()"
              :disabled="edit"
            />
            <div v-if="$v.purchase_price.$error">
              <span
                v-if="!$v.purchase_price.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Precio venta</label>
            <masked-input
              v-model="sales_price"
              :guide="false"
              :mask="mask_quetzal"
              :class="{ 'is-invalid': $v.sales_price.$error }"
              type="text"
              class="form-control"
              @input="$v.sales_price.$touch()"
              :disabled="edit"
            />
            <div v-if="$v.sales_price.$error">
              <span
                v-if="!$v.sales_price.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>

          <div class="form-group">
            <label>Precio especial</label>
            <masked-input
              v-model="special_price"
              :guide="false"
              :mask="mask_quetzal"
              :class="{ 'is-invalid': $v.special_price.$error }"
              type="text"
              class="form-control"
              @input="$v.special_price.$touch()"
              :disabled="edit"
            />
            <div v-if="$v.special_price.$error">
              <span
                v-if="!$v.special_price.required"
                class="help-block help-block-error"
              >El campo es requerido</span>
            </div>
          </div>
        </div>
        <!-- END FORM -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          v-if="tipoAccion == 1"
          @click="saveStock()"
        >Guardar</button>
        <button
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          v-if="tipoAccion == 2"
          @click="updateStock()"
        >Actualizar</button>
      </sweet-modal>
      <sweet-modal ref="activar_modal" icon="info">
        {{tituloModalActivar}}
        <button
          slot="button"
          type="button"
          class="btn btn-info"
          @click="$refs.activar_modal.close()"
        >
          No
        </button>
        <button
          slot="button"
          type="button"
          class="btn btn-danger"
          v-if="tipoAccion == 3"
          @click="deactivateStock()"
        >
          Si
        </button>
        <button
          slot="button"
          type="button"
          class="btn btn-success"
          v-if="tipoAccion == 4"
          @click="activateStock()"
        >
          Si
        </button>
      </sweet-modal>
      <sweet-modal ref="barcode_modal" :title="titleModal" hide-close-button blocking>
        <div align="center">
          <barcode id="barcode" :value="code" :options="{ lineColor: '#0275d8', text: 'Scan'}"></barcode>
        </div>
        <!-- Termina modal -->
        <!-- Botones -->
        <button slot="button" type="button" class="btn btn-danger" @click="closeModal()">Cancelar</button>
        <button
          v-if="tipoAccion == 5"
          slot="button"
          type="button"
          class="btn btn-primary ladda-button"
          data-style="expand-right"
          @click="saveBarcode()"
        >Guardar</button>
      </sweet-modal>
    </div>
    <div v-else class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

</template>


<script>
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import { required, sameAs, minLength, between } from "vuelidate/lib/validators";
import ladda from "ladda";
import html2canvas from 'html2canvas';
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  components: {
    SweetModal,
    SweetModalTab,
    'masked-input': MaskedInput,
  },
  data () {
    return {
      adjustment: true,
      edit: false,
      simple: true,
      mevengo: false,
      checkboxmanual: false,
      arrayPlaces: [],
      arrayMeasure: [],
      arrayProduct: [],
      tituloModalActivar: '',
      stock: 0.0,
      critery: 'code',
      code: '',
      location: '',
      idmeasure: 0,
      idplace: 0,
      idproduct: 0,
      purchase_price: '',
      sales_price: '',
      special_price: '',
      productsArray: [],
      id: 0,
      idproduct: 0,
      tipoAccion: 0,
      titleModal: '',
      equal: '',
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      errorPrices:'',
      offset: 3,
      search: '',
      product: {

      },
      mask_quetzal: createNumberMask({
        prefix: 'Q ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false
      }),
    }
  },
  validations: {
    stock: {
      required,
    },
    location: {
      required,
    },

    code: {
      required,
    },
    idmeasure: {
      required,
    },
    idplace: {
      required,
    },
    idproduct: {
      required,
    },
    purchase_price: {
      required,
    },
    sales_price: {
      required,
    },
    special_price: {
      required,
    }
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber : function(){
        if(!this.pagination.to){
            return [];
        }
        var from = this.pagination.current_page - this.offset;
        if(from < 1){
            from = 1;
        }
        var to = from + (this.offset * 2);
        if(to >= this.pagination.last_page)
        {
            to = this.pagination.last_page;
        }
        var pagesArray = [];
        while(from <= to){
            pagesArray.push(from);
            from++;
        }
        return pagesArray;
    },
  },
  mounted () {
    //this.productnull()
    this.fetchData(1, this.$route.query.item, this.search, this.checkboxmanual);
    this.getProduct(this.$route.query.item)
    this.selectPlaces();
    this.selectProducts();
    this.selectMeasures();
  },
  methods: {
    changePage (page, search, checkboxmanual) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, me.product.id, search, checkboxmanual)
    },
    async fetchData (page, id, search, checkboxmanual) {
      let me = this
      const response = await axios.get(
        `/api/admin/products/stock?page=${page}&id=${id}&search=${search}&checkboxmanual=${checkboxmanual}`
      )
        .then(function (response) {
          var respuesta = response.data
          me.productsArray = respuesta.products.data
          me.pagination = respuesta.pagination
          me.mevengo = true;
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getProduct (id) {
      let me = this
      axios.get(`/api/admin/products/getById?id=${id}`)
        .then(function (response) {
          me.product = response.data.product[0]
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    openModal(accion, data = []) {
      let me = this;
      switch (accion) {
        case "update": {
          this.adjustment=true;
          this.edit=false;
          this.simple=true;
          me.$refs.existencia_modal.open();
          this.titleModal = "Actualizar Existencia";
          this.code = data["code"],
          this.purchase_price = this.formatQuetzales(data['purchase_price'])
          this.sales_price = this.formatQuetzales(data['sales_price'])
          this.special_price = this.formatQuetzales(data['special_price'])
          this.stock = data["stock"],
          this.location = data["location"],
          this.idplace = data["idplace"],
          this.state = data["state"],
          this.id = data["id"];
          this.tipoAccion = 2;
          break;
        }
        case "adjustment": {
          this.adjustment=false;
          this.edit=true;
          this.simple=true;
          me.$refs.existencia_modal.open();
          this.titleModal = "Actualizar Existencia";
          this.code = data["code"],
          this.purchase_price = this.formatQuetzales(data['purchase_price'])
          this.sales_price = this.formatQuetzales(data['sales_price'])
          this.special_price = this.formatQuetzales(data['special_price'])
          this.stock = data["stock"],
          this.location = data["location"],
          this.idmeasure = data["idmeasure"],
          this.idplace = data["idplace"],
          this.idproduct = data["idproduct"],
          this.id = data["id"];
          this.tipoAccion = 2;
          break;
        }
        case "ubicacion": {
          this.adjustment=true;
          this.edit=true;
          this.simple=false;
          me.$refs.existencia_modal.open();
          this.titleModal = "Actualizar Existencia";
          this.code = data["code"],
          this.purchase_price = this.formatQuetzales(data['purchase_price'])
          this.sales_price = this.formatQuetzales(data['sales_price'])
          this.special_price = this.formatQuetzales(data['special_price'])
          this.stock = data["stock"],
          this.location = data["location"],
          this.idmeasure = data["idmeasure"],
          this.idplace = data["idplace"],
          this.idproduct = data["idproduct"],
          this.state = data["state"],
          this.id = data["id"];
          this.tipoAccion = 2;
          break;
        }
        case 'deactivate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea desactivar la existencia?'
          this.id = data['id']
          this.tipoAccion = 3
          break
        }
        case 'activate':
        {
          me.$refs.activar_modal.open()
          this.tituloModalActivar = '¿Desea activar la existencia?'
          this.id = data['id']
          this.tipoAccion = 4
          break
        }
        case 'code':
        {
          me.code = ''
          var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          var charactersLength = characters.length;
          for ( var i = 0; i < 10; i++ ) {
              me.code += characters.charAt(Math.floor(Math.random() * charactersLength));
          }
          break;
        }
        case 'print':
        {
          me.$refs.barcode_modal.open();
          this.code = data['code'];
          this.titleModal = 'Guardar código de barras';
          this.tipoAccion = 5;
          break;
        }
        case 'kardex': {
          me.$router.push({name: 'verKardex',
            params: {
              product: data
            }
          })
          break;
        }
      }
    },
    closeModal() {
      this.$v.$reset();
      this.name = "";
      this.id=0;
      this.$refs.existencia_modal.close();
      this.$refs.barcode_modal.close();
      this.stock = 0.0;
      this.location = '';
      this.idmeasure = 0;
      this.idplace = 0;
      this.idproduct = 0;
      this.id = 0;
      this.titleModal = "";
      this.sales_price='';
      this.special_price='';
      this.purchase_price='';
      this.tituloModalActivar = '';
      this.state = 0;
      this.$refs.activar_modal.close();
      this.errorPrices = '';
      this.fetchData(this.pagination.current_page, this.product.id, this.search, this.checkboxmanual);
    },
    validatePrices(){
      const venta = this.converMaskToNumberxd(this.sales_price);
      const compra = this.converMaskToNumberxd(this.purchase_price);
      const especial = this.converMaskToNumberxd(this.special_price);
      if(Number(compra) > Number(venta)){
        this.errorPrices = 'El precio de compra no puede ser mayor al precio de venta';
      }
      else if(Number(compra) >= Number(especial)){
        this.errorPrices = 'El precio de compra no puede ser mayor al precio especial';
      }
      else if(Number(venta) < Number(especial)){
        this.errorPrices = 'El precio especial no puede ser mayor al precio de venta';
      }
      else if(Number(venta) === Number(especial)){
        this.errorPrices = 'El precio especial no puede ser igual al precio de venta';
      }
      else if(Number(compra) === Number(especial)){
        this.errorPrices = 'El precio especial no puede ser igual al precio de compra';
      }
      else if(Number(compra) === Number(venta)){
        this.errorPrices = 'El precio de venta no puede ser igual al precio de compra';
      }
      else{
        this.errorPrices = ''
      }
    },
    updateStock() {
      var l = ladda.create(document.querySelector(".ladda-button"));
      this.$v.$touch();
      let me = this;

      if (this.$v.$invalid) {
        toastr.error("Revise los campos", "Error");
      }
      else if (this.errorPrices !== '') {
        toastr.error(this.errorPrices, "Error");
      }
      else if (this.edit === false){
        l.start();
        this.validatePrices()
        axios.put("/api/admin/stock/updatex3", {
          code: this.code,
          stock: this.stock,
          location: this.location,
          idmeasure: this.idmeasure,
          idplace: this.idplace,
          state: this.state,
          purchase_price: this.converMaskToNumberxd(this.purchase_price),
          sales_price: this.converMaskToNumberxd(this.sales_price),
          special_price: this.converMaskToNumberxd(this.special_price),
          idproduct: this.idproduct,
          id: this.id
        })
        .then(function(response) {
          toastr.success(response.data.message, "Listo");
          l.stop();
          me.closeModal();
        })
        .catch(function(error) {
          l.stop();
          toastr.error(error.response.data.message, "Error");
        });
      }
      else if (this.simple === false){
        l.start();
        axios.put("/api/admin/stock/update", {
          code: this.code,
          stock: this.stock,
          location: this.location,
          idmeasure: this.idmeasure,
          idplace: this.idplace,
          purchase_price: this.converMaskToNumberxd(this.purchase_price),
          sales_price: this.converMaskToNumberxd(this.sales_price),
          special_price: this.converMaskToNumberxd(this.special_price),
          idproduct: this.idproduct,
          id: this.id,
          action: 1
        })
        .then(function(response) {
          toastr.success(response.data.message, "Listo");
          l.stop();
          me.closeModal();
        })
        .catch(function(error) {
          l.stop();
          toastr.error(error.response.data.message, "Error");
        });
      }
      else if (this.adjustment === false){
        l.start();
        axios.put("/api/admin/stock/update", {
          code: this.code,
          stock: this.stock,
          location: this.location,
          idmeasure: this.idmeasure,
          idplace: this.idplace,
          purchase_price: this.converMaskToNumberxd(this.purchase_price),
          sales_price: this.converMaskToNumberxd(this.sales_price),
          special_price: this.converMaskToNumberxd(this.special_price),
          idproduct: this.idproduct,
          id: this.id,
          action: 2
        })
        .then(function(response) {
          toastr.success(response.data.message, "Listo");
          l.stop();
          me.closeModal();
        })
        .catch(function(error) {
          l.stop();
          toastr.error(error.response.data.message, "Error");
        });
      }
    },
    activateStock() {
      let me = this
      axios.put('/api/admin/stock/activate', {
        id: this.id
      })
      .then(function (response) {
        toastr.success(response.data.message, 'Listo')
        me.closeModal()
      })
      .catch(function (error) {
        toastr.error(error.response.data.message, 'Error')
      });
    },
    deactivateStock() {
      let me = this
      axios.put('/api/admin/stock/deactivate', {
        id: this.id
      })
      .then(function (response) {
        toastr.success(response.data.message, 'Listo')
        me.closeModal()
      })
      .catch(function (error) {
        toastr.error(error.response.data.message, 'Error')
      });
    },
    saveBarcode () {
      window.scrollTo(0, 0);
      html2canvas(document.getElementById("barcode")).then( function (canvas) {
        var a = document.createElement('a');
        a.href = canvas.toDataURL("image/png");
        a.download = 'codigo.png';
        a.click();
      });
    },
    validarTecla: function(e) {
      if (e.keyCode === 13) {

      } else if (e.keyCode === 50) {
        console.log('@ was pressed');
      }
    },
    productnull () {
      if (this.product.id === undefined) {
        this.$router.push({name: 'Productos'
        })
      } else {

        this.fetchData(1, this.product.id, this.search, this.checkboxmanual)
        this.idproduct=this.product.id
      }

    },
    selectPlaces(){
        let me=this;
        var url = '/api/admin/place/getSelect';
        axios.get(url).then(function (response){
          var respuesta = response.data;
          me.arrayPlaces = respuesta.place;
        })
        .catch(function(error){
            console.log(error);
        });
    },
    selectMeasures(){
        let me=this;
        var url = '/api/admin/detail_measure/getMeasures';
        axios.get(url).then(function (response){
          var respuesta = response.data;
          me.arrayMeasure = respuesta.measures;
        })
        .catch(function(error){
            console.log(error);
        });
    },
    selectProducts(){
        let me=this;
        var url = '/api/admin/products/getSelect';
        axios.get(url).then(function (response){
          var respuesta = response.data;
          me.arrayProduct = respuesta.product;
        })
        .catch(function(error){
            console.log(error);
        });
    },
    formatQuetzales (amount) {
      var num = parseFloat(amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return amount = 'Q ' + formatted
    },
    converMaskToNumberxd (number) {
      var myNumber = ''
      for (var i = 0; i < number.length; i += 1) {
        if (number.charAt(i) === 'Q' || number.charAt(i) === ',' || number.charAt(i) === ' ') {
          continue
        } else {
          myNumber += number.charAt(i)
        }
      }
      return parseFloat(myNumber).toFixed(2)
    },
  }
}
</script>
<style>
.error {
  color: #dc3545;
}
.imgRedondo {
  width: 150px !important;
  height: 150px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/products/Stock.vue